/*  Delanima · posterarte-quiz-estilo.js · test de estilo, versión 2
 *  Rehecho el 2026-10-22 (fase 3 de reference/plan-test-estilo.md).
 *
 *  Toda la configuración llega desde Liquid en #pa-quiz-data. Este fichero no
 *  conoce ningún producto.
 *
 *  LA PUNTUACIÓN ES LA DE tools/estilo_simular.py (función puntuar):
 *  principal 1, secundario `pesoSecundario` (0,4), y desempate por número de
 *  elecciones como principal, luego la elección más reciente, luego alfabético.
 *  Si se cambia allí, se cambia aquí; el simulador es el que demuestra que los
 *  8 estilos pueden salir.
 *
 *  El resultado se guarda en localStorage porque el formulario nativo de Shopify
 *  recarga la página al enviar (vuelve con ?customer_posted=true).
 */
(function boot() {
  'use strict';

  // El <script> va con defer; esto es la red si alguien lo mueve al head.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
    return;
  }

  var root = document.querySelector('[data-pa-quiz]');
  if (!root) return;

  var D;
  try { D = JSON.parse(document.getElementById('pa-quiz-data').textContent); }
  catch (e) { return; }

  /* ── saneado: una opción sin lámina tumba su pregunta, no el test ─────── */
  D.preguntas = (D.preguntas || []).filter(function (q) {
    q.opciones = (q.opciones || []).filter(function (o) { return o && o.p && o.p.handle && o.principal; });
    return q.opciones.length >= 2;
  });
  D.pool = (D.pool || []).filter(function (p) { return p && p.handle; });
  if (!D.preguntas.length) return;

  var PESO2 = parseFloat(D.pesoSecundario) || 0.4;
  var TOTAL = D.preguntas.length;
  var STORE = 'pa_quiz_estilo_v2';
  // META no se borra al repetir: cuenta los tests terminados en este navegador y
  // guarda el estilo del primero. Sirve para separar la primera tirada (la reacción
  // espontánea) de las repeticiones, que se miden aparte (2026-10-22).
  var META = 'pa_quiz_estilo_meta';
  var RAPIDA_MS = 1000;  // una elección en menos de 1 s no es mirar, es pulsar
  var st = nuevo();
  function nuevo() { return { i: 0, picks: [], room: null, ms: [], atras: 0, tq: 0 }; }
  function leerMeta() {
    try { var m = JSON.parse(localStorage.getItem(META) || 'null'); if (m && m.n >= 0) return m; } catch (e) {}
    return { n: 0, primero: '' };
  }
  function guardarMeta(m) { try { localStorage.setItem(META, JSON.stringify(m)); } catch (e) {} }
  var bloqueado = false;

  var $ = function (sel) { return root.querySelector(sel); };
  var pantallas = ['portada', 'pregunta', 'inter', 'result'];
  function show(n) {
    pantallas.forEach(function (k) {
      var el = root.querySelector('[data-pa-screen="' + k + '"]');
      if (el) el.hidden = (k !== n);
    });
  }

  /* ── utilidades ───────────────────────────────────────────────────────── */
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function slug(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function save() {
    try { localStorage.setItem(STORE, JSON.stringify({ picks: st.picks.map(function (o) { return o._k; }), room: st.room, ts: Date.now() })); } catch (e) {}
  }
  function restore() {
    try {
      var d = JSON.parse(localStorage.getItem(STORE) || 'null');
      if (!d || !d.picks || d.picks.length !== TOTAL || Date.now() - (d.ts || 0) > 86400000) return null;
      return d;
    } catch (e) { return null; }
  }
  // Cada opción lleva su índice "pregunta.opción" para poder guardarla y recuperarla.
  D.preguntas.forEach(function (q, i) { q.opciones.forEach(function (o, j) { o._k = i + '.' + j; }); });
  function porClave(k) { var a = String(k).split('.'); var q = D.preguntas[+a[0]]; return q && q.opciones[+a[1]]; }

  /* ── puntuación (idéntica a estilo_simular.py) ───────────────────── */
  function ranking(picks) {
    var t = {}, prin = {}, ult = {};
    D.styles.forEach(function (s) { t[s] = 0; prin[s] = 0; });
    picks.forEach(function (o, i) {
      if (o.principal in t) { t[o.principal] += 1; prin[o.principal] += 1; ult[o.principal] = i; }
      if (o.secundario && o.secundario in t) { t[o.secundario] += PESO2; ult[o.secundario] = i; }
    });
    return D.styles.slice().sort(function (a, b) {
      return Math.round((t[b] - t[a]) * 1e9) || (prin[b] - prin[a]) ||
        ((b in ult ? ult[b] : -1) - (a in ult ? ult[a] : -1)) || a.localeCompare(b, 'es');
    });
  }

  /* ── recomendaciones ──────────────────────────────────────────────────── */
  function recs(estilo, segundo) {
    var vistos = {};
    st.picks.forEach(function (o) { vistos[o.p.handle] = true; });
    var out = [], autores = {};
    // El autor es lo que va tras el último « · » del título. Tres láminas del
    // mismo autor se leen como una serie (dos tarots seguidos, 2026-10-22).
    function autor(p) { var t = String(p.title || '').split(' · '); return t.length > 1 ? t[t.length - 1] : p.handle; }
    function push(p) {
      if (!p || vistos[p.handle] || out.length >= 3 || autores[autor(p)]) return;
      vistos[p.handle] = true; autores[autor(p)] = true; out.push(p);
    }
    // Fase 4: la selección curada manda cuando existe.
    var sel = D.selecciones && D.selecciones[estilo];
    if (sel && sel.length) {
      var idx = {}; D.pool.forEach(function (p) { idx[p.handle] = p; });
      sel.forEach(function (h) { push(idx[h]); });
    }
    if (out.length < 3) {
      D.pool.map(function (p) {
        var s = p.styles || [];
        return { p: p, s: (s[0] === estilo ? 3 : s.indexOf(estilo) > -1 ? 2 : 0) + (s.indexOf(segundo) > -1 ? 1 : 0) };
      }).filter(function (x) { return x.s > 0; })
        .sort(function (a, b) { return b.s - a.s; })
        .forEach(function (x) { push(x.p); });
    }
    return out;
  }

  /* ── pantallas ────────────────────────────────────────────────────────── */
  function precarga(i) {
    var q = D.preguntas[i]; if (!q) return;
    q.opciones.forEach(function (o) { if (o.p.img) { var im = new Image(); im.src = o.p.img; } });
  }

  function pregunta() {
    var q = D.preguntas[st.i];
    var barra = '';
    for (var k = 0; k < TOTAL; k++) barra += '<span class="' + (k <= st.i ? 'is-on' : '') + '"></span>';
    $('[data-pa-barra]').innerHTML = barra;
    $('[data-pa-paso]').textContent = pad(st.i + 1) + ' / ' + pad(TOTAL);
    $('[data-pa-back]').hidden = st.i === 0;
    var grid = $('[data-pa-grid]');
    grid.className = 'pa-quiz__rejilla';
    grid.innerHTML = q.opciones.map(function (o, j) {
      return '<button type="button" class="pa-quiz__op" data-pa-op="' + j + '" aria-label="' + esc(o.p.title) + '">' +
        (o.p.img ? '<img src="' + o.p.img + '" alt="' + esc(o.p.alt) + '" loading="eager" decoding="async">' : '') +
        '<span class="pa-quiz__tecla" aria-hidden="true">' + (j + 1) + '</span></button>';
    }).join('');
    show('pregunta');
    st.tq = Date.now();
    precarga(st.i + 1);
  }

  function elegir(j) {
    if (bloqueado) return;
    var q = D.preguntas[st.i], o = q && q.opciones[j];
    if (!o) return;
    bloqueado = true;
    st.picks.push(o);
    st.ms.push(st.tq ? Date.now() - st.tq : 0);
    save();
    var grid = $('[data-pa-grid]');
    grid.classList.add('is-elegida');
    var b = grid.querySelector('[data-pa-op="' + j + '"]'); if (b) b.classList.add('is-si');
    setTimeout(function () {
      grid.classList.add('is-sale');
      setTimeout(function () {
        bloqueado = false;
        st.i++;
        if (st.i >= TOTAL) interludio(); else pregunta();
      }, 250);
    }, 380);
  }

  function interludio() {
    $('[data-pa-tira]').innerHTML = st.picks.map(function (o, i) {
      return o.p.thumb ? '<img src="' + o.p.thumb + '" alt="" style="animation-delay:' + (i * 110) + 'ms">' : '';
    }).join('');
    show('inter');
    var rank = ranking(st.picks);
    var m = leerMeta();
    m.n += 1;
    if (m.n === 1) m.primero = rank[0];
    guardarMeta(m);
    st.intento = m.n;
    medir('test_estilo_completado', datosResultado(rank));
    setTimeout(function () { resultado(rank, false); }, 1300);
  }

  function resultado(rank, compartido) {
    var estilo = rank[0], segundo = rank[1];
    // Sin etiqueta ni descriptor sobre el titular (Javi, 2026-10-22): el estilo habla solo.
    // El nombre del estilo no se parte: «Mid-century» saltaba por el guion (2026-10-22).
    $('[data-pa-res-h1]').innerHTML = (compartido ? 'Estilo ' : 'Tu estilo es ') + '<span style="white-space:nowrap">' + esc(estilo) + '.</span>';
    var seg = $('[data-pa-seg]');
    seg.textContent = compartido || !segundo ? '' : 'Afinidad secundaria: ' + segundo + '.';
    seg.hidden = !seg.textContent;
    $('[data-pa-elec]').innerHTML = compartido ? '' : st.picks.map(function (o) {
      return '<figure>' + (o.p.thumb ? '<img src="' + o.p.thumb + '" alt="">' : '') + '<figcaption>' + esc(o.principal) + '</figcaption></figure>';
    }).join('');
    $('[data-pa-recs-sub]').textContent = 'Elegidas para el estilo ' + estilo.toLowerCase() + '.';
    $('[data-pa-recs]').innerHTML = recs(estilo, segundo).map(function (p) {
      return '<a href="' + p.url + '">' + (p.img ? '<img src="' + p.img + '" alt="' + esc(p.alt) + '" loading="lazy">' : '') +
        '<span class="pa-quiz__rec-t">' + esc(p.title) + '</span><span class="pa-quiz__rec-p">desde ' + esc(p.price) + '</span></a>';
    }).join('');
    composicion(estilo);
    $('[data-pa-shared]').hidden = !compartido;
    $('[data-pa-propio]').hidden = compartido;
    var share = $('[data-pa-share]'); if (share) share.setAttribute('data-estilo', slug(estilo));
    rellenarForm(estilo, segundo);
    show('result');
    window.scrollTo(0, root.getBoundingClientRect().top + window.scrollY - 20);
    if (!compartido) barraFija();
  }

  /* ── composición de pared (fase 4) ────────────────────────────────────── */
  // «Una pared bohemia»: el adjetivo concuerda con «pared».
  var FEM = { 'Nórdico': 'nórdica', 'Clásico': 'clásica', 'Ecléctico': 'ecléctica', 'Bohemio': 'bohemia' };
  function composicion(estilo) {
    var box = $('[data-pa-compo]');
    var c = D.composiciones && D.composiciones[estilo];
    if (!box || !c || !c.img) { if (box) box.hidden = true; return; }
    var img = $('[data-pa-compo-img]'), link = $('[data-pa-compo-link]');
    img.src = c.img + (c.img.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
    img.alt = c.alt || c.titulo || '';
    var piezas = $('[data-pa-compo-piezas]'), medidas = $('[data-pa-compo-medidas]'), cta = $('[data-pa-compo-cta]');
    if (c.tipo === 'pack') {
      $('[data-pa-compo-h]').textContent = c.titulo;
      $('[data-pa-compo-sub]').textContent = 'Las láminas de tu estilo, ya pensadas para colgar juntas.';
      piezas.innerHTML = ''; piezas.hidden = true;
      medidas.textContent = c.precio ? 'Desde ' + c.precio + ' el conjunto.' : ''; medidas.hidden = !c.precio;
      link.href = c.url; $('[data-pa-compo-btn]').href = c.url; cta.hidden = false;
    } else {
      $('[data-pa-compo-h]').textContent = 'Una pared ' + (FEM[estilo] || estilo.toLowerCase());
      $('[data-pa-compo-sub]').textContent = 'Tres láminas de tu estilo, compuestas para colgar juntas.';
      piezas.innerHTML = (c.piezas || []).map(function (p) {
        return '<li><a href="' + esc(p.url) + '">' + esc(p.titulo) + '</a><span>' + esc(p.formato) + '</span></li>';
      }).join('');
      piezas.hidden = false;
      medidas.textContent = 'Ocupa ' + c.huella + '; el centro, a ' + c.centro + ' del suelo.'; medidas.hidden = false;
      link.href = (c.piezas && c.piezas[0] && c.piezas[0].url) || '#';
      cta.hidden = true;
    }
    box.hidden = false;
  }

  /* ── captación (formulario nativo de Shopify; fase 5 lo pasa a Klaviyo) ─ */
  function rellenarForm(estilo, segundo) {
    var tags = $('[data-pa-tags]'), note = $('[data-pa-note]');
    if (!tags || !note) return;
    var t = ['test-estilo', 'test-v' + slug(D.version || '2'), 'estilo-' + slug(estilo), 'afin-' + slug(segundo)];
    if (st.room) t.push('sala-' + slug(st.room));
    if (st.intento) t.push('intento-' + Math.min(st.intento, 5));
    var r = ritmo();
    if (st.ms.length === TOTAL && r.partida === 'rapida') t.push('partida-rapida');
    tags.value = t.join(',');
    note.value = JSON.stringify({
      quiz: 'estilo-decorativo', version: D.version, estilo_asignado: estilo, afinidad_secundaria: segundo,
      habitacion: st.room,
      intento: st.intento || null, primer_estilo: leerMeta().primero || null,
      segundos: st.ms.length === TOTAL ? r.segundos : null, atras: st.atras,
      elecciones: st.picks.map(function (o, i) { return { pregunta: i + 1, tema: D.preguntas[i].tema, lamina: o.p.handle, estilo: o.principal }; })
    });
  }

  // Medición (fase 6): eventos propios que un píxel personalizado de Shopify
  // reenvía a GA4. Shopify los entrega solo si el visitante acepta la analítica.
  // Claves planas y valores cortos: GA4 admite 25 parámetros de hasta 100 caracteres.
  function medir(nombre, datos) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        datos = datos || {};
        datos.test_version = String(D.version || '');
        Shopify.analytics.publish(nombre, datos);
      }
    } catch (x) {}
  }
  function ritmo() {
    var total = 0, rapidas = 0;
    st.ms.forEach(function (x) { total += x; if (x < RAPIDA_MS) rapidas++; });
    // Partida «rápida»: la mitad o más de las elecciones en menos de un segundo.
    return { segundos: Math.round(total / 1000), rapidas: rapidas,
             partida: rapidas * 2 >= TOTAL ? 'rapida' : 'normal' };
  }
  function datosResultado(rank) {
    var r = ritmo(), m = leerMeta();
    var d = { estilo: rank[0], afinidad: rank[1] || '', intento: st.intento || 1,
              primer_estilo: m.primero || rank[0], segundos: r.segundos, rapidas: r.rapidas,
              partida: r.partida, atras: st.atras };
    st.picks.forEach(function (o, i) { d['p' + (i + 1)] = o.p.handle.replace(/^lamina-/, '').slice(0, 100); d['p' + (i + 1) + '_estilo'] = o.principal; });
    return d;
  }

  function validar(e) {
    var f = e.target;
    var v = (f.querySelector('[data-pa-email]').value || '').trim();
    var ok1 = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
    var ok2 = f.querySelector('[data-pa-consent]').checked;
    var e1 = f.querySelector('[data-pa-err-email]'), e2 = f.querySelector('[data-pa-err-consent]');
    e1.textContent = !v ? 'Escribe tu correo para recibir la selección.' : (ok1 ? '' : 'Ese correo no parece válido. Revísalo.');
    e1.hidden = !e1.textContent;
    e2.textContent = ok2 ? '' : 'Marca la casilla para que podamos escribirte.';
    e2.hidden = ok2;
    if (!(ok1 && ok2)) { e.preventDefault(); return; }
    var r = ranking(st.picks);
    medir('test_estilo_correo', { estilo: r[0], habitacion: st.room || '' });
  }

  var observando = false;
  function barraFija() {
    var fija = root.querySelector('[data-pa-fija]'), capt = document.getElementById('pa-quiz-capt');
    if (!fija || !capt) return;
    fija.hidden = false;
    if (observando) return; observando = true;
    var visible = false;
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; actualiza(); }, { threshold: 0.1 }).observe(capt);
    function actualiza() {
      var enResultado = !$('[data-pa-screen="result"]').hidden && $('[data-pa-sent]').hidden;
      fija.classList.toggle('is-fuera', !enResultado || visible || window.scrollY < 300);
    }
    window.addEventListener('scroll', actualiza, { passive: true });
  }

  /* ── eventos ──────────────────────────────────────────────────────────── */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pa-start],[data-pa-op],[data-pa-back],[data-pa-room],[data-pa-restart],[data-pa-share],[data-pa-ir-capt]');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-pa-start')) { st = nuevo(); medir('test_estilo_inicio', { intento: leerMeta().n + 1 }); pregunta(); root.scrollIntoView({ block: 'start' }); }
    else if (t.hasAttribute('data-pa-op')) elegir(+t.getAttribute('data-pa-op'));
    else if (t.hasAttribute('data-pa-back')) { if (st.i > 0 && !bloqueado) { st.picks.pop(); st.ms.pop(); st.atras++; st.i--; save(); pregunta(); } }
    else if (t.hasAttribute('data-pa-room')) {
      var v = t.getAttribute('data-pa-room');
      st.room = st.room === v ? null : v;
      root.querySelectorAll('[data-pa-room]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-pa-room') === st.room); });
      save();
      var r = ranking(st.picks); rellenarForm(r[0], r[1]);
    }
    else if (t.hasAttribute('data-pa-restart')) {
      try { localStorage.removeItem(STORE); } catch (x) {}
      history.replaceState(null, '', location.pathname);
      st = nuevo();
      var fija = root.querySelector('[data-pa-fija]'); if (fija) fija.classList.add('is-fuera');
      show('portada'); root.scrollIntoView({ block: 'start' });
    }
    else if (t.hasAttribute('data-pa-share')) {
      var url = location.origin + location.pathname + '?estilo=' + (t.getAttribute('data-estilo') || '');
      medir('test_estilo_compartir', { estilo: t.getAttribute('data-estilo') || '' });
      var prev = t.textContent, done = function () { t.textContent = 'Enlace copiado'; setTimeout(function () { t.textContent = prev; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
    }
    else if (t.hasAttribute('data-pa-ir-capt')) {
      var c = document.getElementById('pa-quiz-capt'); if (c) c.scrollIntoView({ behavior: 'smooth' });
    }
  });
  var form = $('[data-pa-form]');
  if (form) form.addEventListener('submit', validar);
  document.addEventListener('keydown', function (e) {
    if ($('[data-pa-screen="pregunta"]').hidden || e.altKey || e.ctrlKey || e.metaKey) return;
    if (/^[1-4]$/.test(e.key) && document.activeElement && !/INPUT|TEXTAREA/.test(document.activeElement.tagName)) elegir(+e.key - 1);
  });

  /* ── arranque ─────────────────────────────────────────────────────────── */
  var qs = new URLSearchParams(location.search);
  var compartido = D.styles.filter(function (s) { return slug(s) === qs.get('estilo'); })[0];
  var saved = restore();
  if (qs.get('customer_posted') === 'true' && saved) {
    st.picks = saved.picks.map(porClave).filter(Boolean);
    st.room = saved.room;
    if (st.picks.length === TOTAL) {
      resultado(ranking(st.picks), false);
      var fz = $('[data-pa-form-zona]'), sent = $('[data-pa-sent]');
      if (fz) fz.hidden = true;
      if (sent) sent.hidden = false;
      return;
    }
  }
  if (compartido) resultado([compartido], true);
  else show('portada');
})();

/*  Portada · láminas que rotan (2026-10-27, Javi).
 *  Cada 1,5 s una de las cuatro teselas cambia a otra lámina del grupo
 *  «portada_rotacion» (JSON en [data-pa-rotacion]). La nueva se descubre de abajo
 *  arriba con una máscara (reveal); la transición es CSS (.is-entra →
 *  .is-sube). Las teselas cambian en orden, de la primera a la cuarta y vuelta
 *  a empezar (Javi, 2026-10-27), y nunca se repite una
 *  lámina que ya esté a la vista.
 *  Quieta con «reducir movimiento», con la pestaña oculta y en cuanto la
 *  portada deja de verse (el test ha empezado). El grupo no se descarga al
 *  abrir: cada lámina se pide y se decodifica una vuelta antes de entrar.
 */
(function rotacion() {
  'use strict';
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rotacion, { once: true });
    return;
  }
  var mos = document.querySelector('[data-pa-mosaico]');
  var datos = document.querySelector('[data-pa-rotacion]');
  if (!mos || !datos) return;
  var grupo;
  try { grupo = JSON.parse(datos.textContent); } catch (e) { return; }
  var teselas = [].slice.call(mos.querySelectorAll('.pa-quiz__tesela'));
  grupo = (grupo || []).filter(function (p) { return p && p.h && p.src; });
  if (teselas.length < 2 || grupo.length <= teselas.length) return;

  var PASO = 1500, SEGURO = 1600;   // 1,5 s entre cambios (Javi, 2026-10-27); el reveal dura 1,1
  var quieto = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var portada = mos.closest('[data-pa-screen]');
  var primera = teselas[0].querySelector('img');
  var sizes = (primera && primera.getAttribute('sizes')) || '';
  var visibles = teselas.map(function (t) { return t.getAttribute('data-h'); });
  var turno = 0, cola = [], proxima = null, ocupado = false;

  function barajar(a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var x = a[i]; a[i] = a[j]; a[j] = x; }
    return a;
  }
  function siguienteTesela() {
    var i = turno;
    turno = (turno + 1) % teselas.length;
    return i;
  }
  function siguienteLamina() {
    for (var n = 0; n < grupo.length * 2; n++) {
      if (!cola.length) cola = barajar(grupo.slice());
      var p = cola.shift();
      if (visibles.indexOf(p.h) === -1) return p;
    }
    return null;
  }
  function preparar() {
    var p = siguienteLamina();
    if (!p) return;
    var im = new Image();
    im.alt = '';
    im.decoding = 'async';
    if (p.srcset) { im.srcset = p.srcset; im.sizes = sizes; }
    im.src = p.src;
    var item = { p: p, im: im, roto: false };
    item.lista = cargada(item);
    proxima = item;
  }
  // Espera a que la lámina cargue y, si se puede, a que se decodifique. No se fía
  // solo de decode(): en Chrome de Android, con la imagen fuera del documento y
  // srcset, la promesa no se resolvía nunca y la portada se quedaba quieta en el
  // móvil (2026-10-27). La carga, un tope de 4 s y un decode de 250 ms como mucho.
  function cargada(item) {
    var im = item.im;
    return new Promise(function (listo) {
      var hecho = false;
      var fin = function () { if (!hecho) { hecho = true; listo(); } };
      if (im.complete && im.naturalWidth) fin();
      im.addEventListener('load', fin, { once: true });
      im.addEventListener('error', function () { item.roto = true; fin(); }, { once: true });
      setTimeout(fin, 4000);
    }).then(function () {
      if (item.roto || !im.decode) return;
      return Promise.race([im.decode().catch(function () {}), new Promise(function (r) { setTimeout(r, 250); })]);
    });
  }
  function tick() {
    if (quieto.matches || document.hidden || (portada && portada.hidden) || ocupado) return;
    if (!proxima) { preparar(); return; }
    var item = proxima;
    proxima = null;
    ocupado = true;
    item.lista.then(function () {
      if (item.roto) { ocupado = false; preparar(); return; }   // no cargó: se salta
      var i = siguienteTesela();
      var t = teselas[i];
      var nuevo = item.im;
      nuevo.className = 'is-entra';
      t.appendChild(nuevo);
      void nuevo.offsetWidth;            // fija la posición de salida antes de animar
      nuevo.className = 'is-sube';
      var hecho = false;
      var fin = function () {
        if (hecho) return;
        hecho = true;
        [].slice.call(t.querySelectorAll('img')).forEach(function (x) { if (x !== nuevo) x.remove(); });
        nuevo.className = '';
        ocupado = false;
      };
      nuevo.addEventListener('transitionend', fin, { once: true });
      setTimeout(fin, SEGURO);
      visibles[i] = item.p.h;
      t.setAttribute('data-h', item.p.h);
      preparar();
    });
  }

  // Arranca con la página cargada o, como tarde, a los 2 s: en el móvil el `load`
  // puede tardar mucho por scripts de terceros, y la portada no debe esperarlos.
  var arrancada = false;
  function arrancar() {
    if (arrancada) return;
    arrancada = true;
    preparar();
    setInterval(tick, PASO);
  }
  if (document.readyState === 'complete') arrancar();
  else {
    window.addEventListener('load', arrancar, { once: true });
    setTimeout(arrancar, 2000);
  }
})();
